var React = require('react');

function LeftPink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E990B0","fillRule":"evenodd","d":"M-80.8120161,552.277836 C28.6814106,537.90929 105.718292,437.489235 91.2550426,327.983308 C76.7917928,218.477381 -23.6951061,141.353618 -133.187984,155.722164 C-242.681411,170.09071 -319.718292,270.511313 -305.255043,380.016692 C-290.791793,489.522619 -190.305443,566.646382 -80.8120161,552.277836","transform":"translate(0 -185)"}));
}

LeftPink.defaultProps = {"width":"93","height":"338","viewBox":"0 0 93 338"};

module.exports = LeftPink;

LeftPink.default = LeftPink;
